import { getField, updateField } from "vuex-map-fields";
import supplCertn from "./supplCertn";
import main from "./main";

const getDefaultState = () => {
  return {};
};

const common = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getField,
  },
  mutations: {
    updateField,
    resetState: state => {
      Object.assign(state, getDefaultState());
    },
  },
  actions: {
    actAllStateReset({ commit }) {
      // commit("resetState");
      commit("main/resetState");
      // commit("supplCertn/resetState");
    },
  },
  modules: {
    supplCertn,
    main,
  },
};

export default common;
